import React from 'react';
import { Box, Typography } from '@mui/material';
import { Science as ScienceIcon } from '@mui/icons-material';
import MethodManagement from '../components/admin/MethodManagement';

/**
 * Method Management Page
 * Dedicated page for laboratory method administration
 */
const MethodManagementPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <ScienceIcon sx={{ fontSize: 32 }} />
          Gestion des Méthodes d'Analyse
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Administration des méthodes de laboratoire - AFRILAB LIMS
        </Typography>
      </Box>

      {/* Method Management Component */}
      <MethodManagement />
    </Box>
  );
};

export default MethodManagementPage;
